import { useEffect, useRef, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { reviewRequest } from './ManualReviewDialog';

type Job = { id:number; action:string; outcomes:Record<string,string> };
export function UnitRefreshButton({rowId,onSaved}:{rowId?:string;onSaved:()=>void|Promise<void>}) {
  const [running,setRunning]=useState(false),[submitting,setSubmitting]=useState(false),[job,setJob]=useState<Job|null>(null),[error,setError]=useState('');
  const [attempt,setAttempt]=useState(0);
  const activeJobId=useRef(0);
  const saved=useRef(onSaved);saved.current=onSaved;
  const wasRunning=useRef(false);
  useEffect(()=>{
    if(!rowId)return;
    let active=true,timer:ReturnType<typeof setTimeout>;
    const poll=async()=>{
      try{
        const result=await reviewRequest(`/claro/api/audit/deep/review/refresh?rowId=${encodeURIComponent(rowId)}`);
        if(!active)return;
        const next=result.job as Job|null,busy=next?.action==='refresh_started';
        if(activeJobId.current&&(!next||next.id<activeJobId.current)){timer=setTimeout(poll,2500);return;}
        setJob(next);setRunning(busy);setError('');
        if(wasRunning.current&&!busy)await saved.current();
        wasRunning.current=busy;
        if(active)timer=setTimeout(poll,busy?2500:10000);
      }catch(failure){if(active){setError(failure instanceof Error?failure.message:String(failure));timer=setTimeout(poll,10000);}}
    };
    void poll();return()=>{active=false;clearTimeout(timer);};
  },[rowId,attempt]);
  const start=async()=>{
    if(!rowId)return;setSubmitting(true);setError('');
    try{
      const result=await reviewRequest('/claro/api/audit/deep/review/refresh',{method:'POST',body:JSON.stringify({rowId})});
      activeJobId.current=result.id;wasRunning.current=true;setRunning(true);setJob(null);setAttempt(value=>value+1);
    }catch(failure){setError(failure instanceof Error?failure.message:String(failure));}
    finally{setSubmitting(false);}
  };
  const names:Record<string,string>={receita:'Receita',alvaraFuncionamento:'Alvará',avcb:'AVCB'};
  return <div className="space-y-2"><Button size="sm" variant="outline" disabled={!rowId||running||submitting} onClick={()=>void start()}><RefreshCw className={`mr-2 h-4 w-4 ${running?'animate-spin':''}`}/>{running?'Atualizando esta unidade…':submitting?'Iniciando…':'Atualizar esta unidade'}</Button>
    {running&&<p className="max-w-sm text-xs text-muted-foreground">Buscando Receita e relendo Alvará e AVCB deste cadastro. Você pode fechar esta janela.</p>}
    {error&&<p role="alert" className="max-w-sm text-xs text-destructive">{error}</p>}
    {!running&&job&&<div className="max-w-sm text-xs text-muted-foreground">{job.action==='refresh_interrupted'?'A atualização anterior foi interrompida.':job.action==='refresh_failed'?'Atualização não concluída.':'Última atualização desta unidade:'}{Object.entries(job.outcomes).map(([source,result])=><p key={source}>{names[source]||source}: {result}</p>)}</div>}
  </div>;
}
